import { z } from 'zod/v4';

export const TemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  companyId: z.string(),
  isGlobal: z.boolean(),
  isArchived: z.boolean(),
  isActive: z.boolean(),
  isPreference: z.boolean(),
  tracingType: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TemplateType = z.infer<typeof TemplateSchema>;
